export default defineNuxtRouteMiddleware(async (to, from) => {
  if (to.path === "/invite/select-oauth" && from.path === "/invite") {
    return;
  }
  if (to.path === "/invite/oauth" && from.path === "/invite/select-oauth") {
    return;
  }
  return navigateTo("/login");
});
